'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Slide = undefined;

var _Slide2 = require('./Slide');

var _Slide3 = _interopRequireDefault(_Slide2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.Slide = _Slide3.default;


//////////////////
// WEBPACK FOOTER
// ./src/components/CartProduct/Slider/default/Slide/index.js
// module id = 1635
// module chunks = 0